import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import { ADEMONTE, DEMONTE, MONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import moment from 'moment';
import { LISTE_DESCRIPTION_TLPE } from '@/configuration/gabed/tlpe/tlpeConf';
import booleanConverter from '@/services/import/General/booleanConverter';
import i18n from '@/i18n';

export default function fillMaterielWithData(materielReference, materiel, informationApiReference) {
  materiel.code = materielReference.codeMateriel ?? '';
  materiel.typeId = store
    .getters['parametres/parametre'](PARAMETRES_KEYS.materielType).find((type) => {
      return type.libelle.toLowerCase().trim()
        === materielReference.typeMateriel.toLowerCase().trim();
    }).id;
  materiel.disposition = materielReference.dispositionMateriel ?? '';
  materiel.enVenantDe = materielReference.enVenantDeMateriel ?? '';
  materiel.enAllantVers = materielReference.enAllantVersMateriel ?? '';
  const formatWithInformation = store
    .getters['parametres/parametre'](PARAMETRES_KEYS.materielFormat).find((format) => {
      return format.libelle
        === materielReference.formatMateriel;
    });
  materiel.formatId = formatWithInformation.id ?? null;
  materiel.surface.surfaceCommerciale = formatWithInformation.surfaceCommercialPerso;
  materiel.surface.surfaceTlpe = formatWithInformation.surfaceTlpePerso;
  if (materielReference.declarableMairieMateriel) {
    materiel.declarableEnMairie = booleanConverter(materielReference.declarableMairieMateriel);
  }
  if (materielReference.dateMontageMateriel) {
    const dateDefault = moment('31/12/1899', 'DD/MM/YYYY');
    let date = moment(materielReference.dateMontageMateriel, 'DD/MM/YYYY');
    if (dateDefault.isSame(date)) date = date.add(1, 'd');
    materiel.dateMontage = formatDate(date);
  } else materiel.dateMontage = null;
  materiel.dateDemontage = materielReference.dateDemontageMateriel ? formatDate(moment(materielReference.dateDemontageMateriel, 'DD/MM/YYYY')) : null;

  materiel.typeTaxationTlpeId = materielReference.typeTaxationTlpe ? informationApiReference
    .typeTaxationTlpe.find((type) => {
      return type.libelle === materielReference.typeTaxationTlpe;
    }) : null;

  if (materielReference.etatMateriel === 'Monté' || materielReference.etatMateriel === 'Monte') {
    materiel.etat = MONTE;
  } else if (materielReference.etatMateriel === 'Démonté' || materielReference.etatMateriel === 'Demonte') {
    materiel.etat = DEMONTE;
  } else if (materielReference.etatMateriel === 'A démonté') {
    materiel.etat = ADEMONTE;
  }

  materiel.descriptionTlpe = materielReference.descriptionTlpeMateriel
    ? LISTE_DESCRIPTION_TLPE.find((desc) => {
      return i18n.t(desc.libelle) === materielReference.descriptionTlpeMateriel;
    }).code : LISTE_DESCRIPTION_TLPE[0].code;

  materiel.collectiviteId = materielReference.collectiviteTlpe
    ? informationApiReference
      .collectivite.find((collec) => {
        return collec.nomCommercial === materielReference.collectiviteTlpe;
      }).id : null;

  materiel.visibleSurLa = materielReference.visibleSurLaMateriel ?? null;
  if (materielReference.visibleFeuMateriel) {
    materiel.visibleDunFeu = booleanConverter(materielReference.visibleFeuMateriel);
  }
  if (materielReference.visibleIntersectionMateriel) {
    materiel.visibleDuneIntersection = booleanConverter(
      materielReference.visibleIntersectionMateriel,
    );
  }
  if (materielReference.eclaireMateriel) {
    materiel.eclaire = booleanConverter(materielReference.eclaireMateriel);
  }
  materiel.angleVisionId = materielReference.angleVisionMateriel ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.materielAngleVision).find((type) => {
      return type.libelle === materielReference.angleVisionMateriel.toString();
    }).id : null;
  materiel.localisationId = materielReference.localisationMateriel ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.materielLocalisation).find((type) => {
      return type.libelle.toLowerCase().trim()
        === materielReference.localisationMateriel.toLowerCase().trim();
    }).id : null;
  materiel.azimut = materielReference.azimut ?? null;
  materiel.isolement = booleanConverter(materielReference.isolementMateriel);
  materiel.ecartAxe = materielReference.ecartAxeMateriel ?? '';
  materiel.ecartVoie = materielReference.ecartVoieMateriel ?? '';
  materiel.longueurApproche = materielReference.longueurApprocheMateriel ?? '';
  materiel.commentaire = materielReference.commentaireMateriel ?? null;
  materiel.materielTechnique.typeEclairage = materielReference.typeEclairage ?? '';
  materiel.materielTechnique.passerelle = booleanConverter(materielReference.passerelleMateriel);
  materiel.numLigne = materielReference.numLigne;
  return materiel;
}
